var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlignItemsCenterHorizontalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 22,
    viewBox: "0 0 27 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.33398 21.7778V12.4445H0.333984V9.77779H4.33398V0.444458H12.334V9.77779H15.0007V4.44446H23.0007V9.77779H27.0007V12.4445H23.0007V17.7778H15.0007V12.4445H12.334V21.7778H4.33398Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignItemsCenterHorizontalIcon);
export default __webpack_public_path__ + "static/media/align-items-center-horizontal-icon.118aaa7b7c222116511ee9a511254c1d.svg";
export { ForwardRef as ReactComponent };